import store from '../../../store/store';
import { asyncHandler } from '../async-handler';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { ACTION_RULE_URL } from './action-api-urls';
import { ShopActionRule } from './action-types';

export interface UpdateActionRuleRequest {
  action_type_id?: string | null;
  platform?: string | null;
  name?: string;
  conditions?: {
    max_percentage_change?: number;
    max_absolute_change?: number;
    allowed_transitions?: string[];
    risk_level_max?: string;
  };
  max_daily_auto_approvals?: number;
  is_active?: boolean;
}

export interface UpdateActionRuleResponse {
  success: boolean;
  message: string | null;
  data: ShopActionRule | null;
}

export default async function update_action_rule_api_call(
  ruleId: string,
  ruleData: UpdateActionRuleRequest
): Promise<ShopActionRule | null> {
  try {
    const shopSlug = store.getState().user?.company?.shop_slug;
    const accessToken = store.getState().auth.authorization.accessToken;
    const sellerToken = accessToken?.sellerToken;

    const requestInfo: RequestInfo = {
      url: ACTION_RULE_URL(shopSlug, ruleId),
      method: 'PUT',
      body: JSON.stringify(ruleData),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: accessToken.type + ' ' + sellerToken,
      },
    };

    const actionType = 'UPDATE_ACTION_RULE';
    const customMsg = 'Action rule updated successfully.';

    const res: any = await asyncHandler(
      requestInfo,
      actionType,
      customMsg,
      true,
      false
    );

    const response: UpdateActionRuleResponse = res?.data;

    if (res?.actionType === actionType && response?.success === true) {
      return response.data;
    } else {
      return null;
    }
  } catch (exception) {
    console.log('Error during update action rule request');
    return null;
  }
}
